import { getTranslation } from '@easy-expense/intl-client';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';

import { BillingTerm } from '../../../lib/Paddle';

export const TermToggle: React.FC<{
  term: BillingTerm;
  setTerm: (term: BillingTerm) => void;
  disableMonthly?: boolean;
  // Annual-savings badge copy. Defaults to the Team plan's exact 25% discount;
  // callers showing multiple plans with different discounts (e.g. the plan
  // ladder) pass an accurate range instead.
  savingsLabel?: string;
}> = ({ term, setTerm, disableMonthly = false, savingsLabel }) => {
  const badgeLabel = savingsLabel ?? getTranslation('Save 25%');
  return (
    <Layout.Row
      radius={100}
      border={[1, 'solid', 'grayLight']}
      bg="white"
      align
      style={{ alignSelf: 'flex-start' }}
      role="group"
      aria-label={getTranslation('Billing period')}
    >
      <Layout.PressableColumn
        bg={term === 'monthly' ? 'brandPrimaryXLight' : 'white'}
        border={term === 'monthly' ? [1, 'solid', 'brandPrimary'] : undefined}
        radius={100}
        px={20}
        py={8}
        onClick={() => {
          if (disableMonthly) {
            return;
          }
          setTerm('monthly');
        }}
        center
        style={disableMonthly ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
        type="button"
        aria-pressed={term === 'monthly'}
        aria-disabled={disableMonthly}
      >
        <OpenSans.Primary
          weight="bold-700"
          color={term === 'monthly' ? 'brandPrimary' : undefined}
          size="s-16"
        >
          {getTranslation('Monthly')}
        </OpenSans.Primary>
      </Layout.PressableColumn>
      <Layout.PressableRow
        bg={term === 'annual' ? 'brandPrimaryXLight' : 'white'}
        border={term === 'annual' ? [1, 'solid', 'brandPrimary'] : undefined}
        radius={100}
        px={20}
        py={8}
        onClick={() => setTerm('annual')}
        align
        type="button"
        aria-pressed={term === 'annual'}
      >
        <OpenSans.Primary
          weight="bold-700"
          color={term === 'annual' ? 'brandPrimary' : undefined}
          size="s-16"
        >
          {getTranslation('Annual')}
        </OpenSans.Primary>
        <Spacer.Horizontal size={8} />
        <Layout.Row bg="successDark" radius={100} px={8} py={2}>
          <OpenSans.Primary color="white" weight="bold-700" size="xs-12">
            {badgeLabel}
          </OpenSans.Primary>
        </Layout.Row>
      </Layout.PressableRow>
    </Layout.Row>
  );
};
